import { useEffect, useState } from 'react';
import { useScreenSize } from '@/exceed';

export default () => {
  const [view, setView] = useState(localStorage.getItem('videosBrowseView') || 'tile');

  const screenSize = useScreenSize();

  if ((screenSize === 'small' || screenSize === 'xsmall') && view === 'list') {
    setView('tile');
    localStorage.setItem('videosBrowseView', 'tile');
  };

  useEffect(() => {
    localStorage.setItem('videosBrowseView', view);
  }, [view]);

  const onLoadMore = () => {
    // TODO work out pagination with react query
  };

  const onViewChanged = (layoutView) => {
    setView(layoutView);
  };

  return {
    onLoadMore,
    onViewChanged,
    view,
  };
};
